export const csvDownload = (headers, rows, row, name) => {
  const body = [];
  const datetime = new Date()?.toISOString?.().replace?.(/[-T:.Z]/g, '');
  body?.push?.(headers?.join?.(';'));
  rows?.forEach?.((r, i) => body?.push?.(row?.(r, i)?.join?.(';')));
  const data = encodeURI?.(`data:text/csv;charset=utf-8,${body.join?.('\n')}`);
  const link = document?.createElement?.('a');
  link?.setAttribute?.('href', data);
  link?.setAttribute?.('download', `${name}-${datetime}.csv`);
  document?.body?.appendChild?.(link);
  link?.click?.();
  document?.body?.removeChild?.(link);
};
